import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../assets/flag-fi.svg'
import _imports_1 from '../assets/flag-sv.svg'
import _imports_2 from '../assets/flag-gb.svg'
import _imports_3 from '../assets/down-rounded.svg'


const _withScopeId = n => (_pushScopeId("data-v-6861f0ba"),n=n(),_popScopeId(),n)
const _hoisted_1 = { id: "navi-language" }
const _hoisted_2 = {
  key: 0,
  class: "item"
}
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", { src: _imports_0 }, null, -1))
const _hoisted_4 = {
  key: 1,
  class: "item"
}
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", { src: _imports_1 }, null, -1))
const _hoisted_6 = {
  key: 2,
  class: "item"
}
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", { src: _imports_2 }, null, -1))
const _hoisted_8 = { key: 3 }
const _hoisted_9 = {
  key: 0,
  class: "languages"
}
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", { src: _imports_0 }, null, -1))
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", { src: _imports_1 }, null, -1))
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", { src: _imports_2 }, null, -1))

import { ref } from "vue";
import { index } from "@/store/index";
import { translate } from '@/util/intl';


export default /*#__PURE__*/_defineComponent({
  __name: 'LanguageSelector',
  setup(__props) {

const menuOpen = ref(false);
const currentLanguage = ref(index.getters.locale.slice(0, 2)); 

function toggleMenu(): void {
  menuOpen.value = !menuOpen.value;
}

function showFinnish(): boolean {
  const lang: string = currentLanguage.value;
  return lang === "sv" || lang === "en";
}

function showSwedish(): boolean {
  const lang: string = currentLanguage.value;
  return lang === "fi" || lang === "en";
}

function showEnglish(): boolean {
  const lang: string = currentLanguage.value;
  return lang === "fi" || lang === "sv";
}

function changeLanguage(language: string): void {
  // DO NOT index.getters.country here because WW has no i18n support
  // also country should never change outside CountryAndLanguageInitialization
  const localeCountry = index.getters.locale.slice(-2);
  const newLocale = language + "-" + localeCountry;
  index.commit("CHANGE_LOCALE", newLocale);
  currentLanguage.value = language;
  toggleMenu();
}

// global autoclose on click elsewhere
document.addEventListener('click', (event: MouseEvent) => {
  const action = event.target as Node;
  const dropDown = document.getElementById('navi-language') as HTMLElement;
  const hamburger = document.getElementById('hamburger-menu-functions') as HTMLElement;
  let inBurger = false; //clicks in this element get hijacked preventing open idk why
  if (hamburger !== null && hamburger?.contains(action)) {
    inBurger = true;
  }
  if (!dropDown?.contains(action) && !inBurger) {
    menuOpen.value = false;
  }
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      id: "selected-language",
      onClick: _cache[0] || (_cache[0] = ($event: any) => (toggleMenu()))
    }, [
      (currentLanguage.value == 'fi')
        ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
            _hoisted_3,
            _createElementVNode("h4", null, _toDisplayString(_unref(translate)("lang-finnish")), 1)
          ]))
        : (currentLanguage.value == 'sv')
          ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
              _hoisted_5,
              _createElementVNode("h4", null, _toDisplayString(_unref(translate)("lang-swedish")), 1)
            ]))
          : (currentLanguage.value == 'en')
            ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                _hoisted_7,
                _createElementVNode("h4", null, _toDisplayString(_unref(translate)("lang-english")), 1)
              ]))
            : (_openBlock(), _createElementBlock("div", _hoisted_8, "ERR")),
      _createElementVNode("img", {
        class: _normalizeClass(["filter-darker", {'flip': menuOpen.value}]),
        src: _imports_3
      }, null, 2)
    ]),
    (menuOpen.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
          (showFinnish())
            ? (_openBlock(), _createElementBlock("div", {
                key: 0,
                class: "item",
                onClick: _cache[1] || (_cache[1] = ($event: any) => (changeLanguage('fi')))
              }, [
                _hoisted_10,
                _createElementVNode("h4", null, _toDisplayString(_unref(translate)("lang-finnish")), 1)
              ]))
            : _createCommentVNode("", true),
          (showSwedish())
            ? (_openBlock(), _createElementBlock("div", {
                key: 1,
                class: "item",
                onClick: _cache[2] || (_cache[2] = ($event: any) => (changeLanguage('sv')))
              }, [
                _hoisted_11,
                _createElementVNode("h4", null, _toDisplayString(_unref(translate)("lang-swedish")), 1)
              ]))
            : _createCommentVNode("", true),
          (showEnglish())
            ? (_openBlock(), _createElementBlock("div", {
                key: 2,
                class: "item",
                onClick: _cache[3] || (_cache[3] = ($event: any) => (changeLanguage('en')))
              }, [
                _hoisted_12,
                _createElementVNode("h4", null, _toDisplayString(_unref(translate)("lang-english")), 1)
              ]))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true)
  ]))
}
}

})